import { Fragment, useRef } from 'react';
import { Popover, Transition, Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const timeoutDuration = 120;
export default function Flyout({ links, title, clearTimeOut, setTimeOutID }) {
  const triggerRef = useRef();

  const handleEnter = (isOpen) => {
    clearTimeOut();
    !isOpen && triggerRef.current?.click();
  };

  const handleLeave = (isOpen) => {
    clearTimeOut();
    if (isOpen) {
      setTimeOutID(
        setTimeout(() => {
          triggerRef.current?.click();
        }, timeoutDuration)
      );
    }
  };

  return (
    <Popover className="relative">
      {({ open }) => (
        <div onMouseEnter={() => handleEnter(open)} onMouseLeave={() => handleLeave(open)}>
          <Popover.Button
            className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-white hover:!text-green-bright focus:ring-0 focus:ring-offset-0"
            ref={triggerRef}
          >
            {title}
            <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute top-full z-10 -left-8 mt-1 w-screen max-w-xs overflow-hidden rounded-lg bg-header-background shadow-lg ring-1 ring-gray-900/5">
              <div className="p-3">
                {links.map((link) => (
                  <div
                    key={link.name}
                    className="group relative flex items-center gap-x-2 rounded-md p-4 text-sm leading-6 hover:bg-gray-600"
                  >
                    <div className="flex-auto">
                      {link.nestedLinks ? (
                        <Disclosure>
                          {({ open }) => (
                            <>
                              <Disclosure.Button className="flex justify-between w-full">
                                <a
                                  href={link.href}
                                  className="block font-bold text-gray-200 no-underline hover:!text-green-bright"
                                >
                                  {link.name}
                                </a>
                                <ChevronDownIcon
                                  className={`${
                                    open ? 'transform rotate-180' : ''
                                  } w-5 h-5 text-gray-200`}
                                />
                              </Disclosure.Button>
                              <Disclosure.Panel className="mt-2 space-y-2 flex flex-col">
                                {link.nestedLinks.map((nestedLink) => (
                                  <a
                                    key={nestedLink.name}
                                    href={nestedLink.href}
                                    className="text-sm text-white no-underline ml-2 hover:!text-green-bright"
                                  >
                                    {nestedLink.name}
                                  </a>
                                ))}
                              </Disclosure.Panel>
                            </>
                          )}
                        </Disclosure>
                      ) : (
                        <a
                          href={link.href}
                          className="block text-white no-underline font-bold hover:!text-green-bright"
                        >
                          {link.name}
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
}
